import { render, staticRenderFns } from "./ProvisaoResumo.vue?vue&type=template&id=decc4fca&scoped=true"
import script from "./ProvisaoResumo.vue?vue&type=script&lang=ts"
export * from "./ProvisaoResumo.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoResumo.vue?vue&type=style&index=0&id=decc4fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decc4fca",
  null
  
)

export default component.exports